import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrEmptyFileIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M4.00078 1.6998C3.8351 1.6998 3.70078 1.83412 3.70078 1.9998V13.9998C3.70078 14.1655 3.8351 14.2998 4.00078 14.2998H12.5008C12.6665 14.2998 12.8008 14.1655 12.8008 13.9998V5.6998H10.2073C9.26844 5.6998 8.50732 4.93869 8.50732 3.9998V1.6998H4.00078ZM9.90732 2.60867V3.9998C9.90732 4.16549 10.0416 4.2998 10.2073 4.2998H11.7225L9.90732 2.60867ZM2.30078 1.9998C2.30078 1.06092 3.0619 0.299805 4.00078 0.299805H9.20732C9.38441 0.299805 9.55492 0.366923 9.68449 0.487635L13.978 4.48764C14.1201 4.62005 14.2008 4.80556 14.2008 4.9998V13.9998C14.2008 14.9387 13.4397 15.6998 12.5008 15.6998H4.00078C3.06189 15.6998 2.30078 14.9387 2.30078 13.9998V1.9998Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrEmptyFileIconComponent;
